import { render, staticRenderFns } from "./CardTarjaBBBEliminacao.vue?vue&type=template&id=04e515be&scoped=true"
import script from "./CardTarjaBBBEliminacao.vue?vue&type=script&lang=js"
export * from "./CardTarjaBBBEliminacao.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaBBBEliminacao.vue?vue&type=style&index=0&id=04e515be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e515be",
  null
  
)

export default component.exports